<template><svg v-bind="$attrs"  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 11 16">
  <path fill="#126782" d="M10.068 8.605a.826.826 0 0 0 0-1.21L2.49.247c-.39-.33-.976-.33-1.328 0l-.898.843c-.352.33-.352.88 0 1.247l6.015 5.645-6.015 5.681c-.352.367-.352.917 0 1.246l.898.844c.352.33.938.33 1.328 0l7.578-7.148z"/>
</svg>
</template>